import { Badge } from '@change/ds-core-ui';
import { SelectionCard, SelectionCardGroup } from '@change/ds-forms';
import { StarIcon } from '@change/ds-icons';

import { useAmountSelector } from './hooks/useAmountSelector';

export const AmountSelector: React.FC = () => {
	const {
		data: {
			buttonAmounts,
			selection,
			customAmount,
			customInputRef,
			amountErrorText,
			customAmountLabel,
			currencySymbol,
			currencySymbolPosition,
		},
		actions: { handleAmountChange, handleCustomAmountFocus, handleCustomAmountChange },
	} = useAmountSelector();

	return (
		<SelectionCardGroup
			name="impression-amount-selector"
			aria-label=""
			label=""
			labelIsVisible={false}
			variant="list"
			value={selection}
			onChange={handleAmountChange}
			data-qa="promotion-impression-amount-selector"
			colorVariant="blue"
		>
			{buttonAmounts.map(({ value, label, valueDisplay, bonusLabel, metaText }) => (
				<SelectionCard
					data-qa="suggested-amount-button"
					key={value}
					value={value.toString()}
					valueDisplay={valueDisplay}
					label={label}
					metaText={metaText}
					badgeBottom={
						bonusLabel ? <Badge leadingIcon={<StarIcon />} label={bonusLabel} variant="information" /> : undefined
					}
				/>
			))}
			<SelectionCard
				value="custom"
				label={customAmountLabel}
				isInvalid={!!amountErrorText}
				hasInput
				data-qa="payment-form-custom-amount-button"
				currencySymbol={currencySymbol}
				currencySymbolPosition={currencySymbolPosition}
				inputProps={
					// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-unsafe-type-assertion
					{
						ref: customInputRef,
						placeholder: customAmountLabel,
						errorMessage: amountErrorText,
						value: customAmount,
						onFocus: handleCustomAmountFocus,
						onChange: handleCustomAmountChange,
						inputMode: 'numeric',
						// TODO: Remove this casting when TextField props are typed to allow these attributes
						// https://change.atlassian.net/browse/CHANGE-77254
						'data-qa': 'custom-amount-input',
						// eslint-disable-next-line @typescript-eslint/no-explicit-any
					} as any
				}
			/>
		</SelectionCardGroup>
	);
};
